const changeViewDropdown = {
  company: {
    body: 'Tem certeza de que deseja mudar de empresa?',
  },
  site: {
    body: 'Tem certeza de que deseja mudar de site?',
  },
};

export default changeViewDropdown;
